import arrow from './arrow.svg';
import close from './close.svg';
import chevron from './chevron.svg';
import play from './play.svg';
import chevronRight from './chevron-right.svg';

export default {
    arrow,
    close,
    chevron,
    play,
    chevronRight
}